import React from 'react'

import styles from './styles'

const Footer = () => (
  <footer style={styles.container}>
    <div style={styles.contact}>
      <i className="fa fa-envelope-open-o" style={styles.icon} />
      bobby@bobbyhacker.tv
    </div>
    <div style={styles.contact}>
      <i className="fa fa-phone" style={styles.icon} />
      310.890.4675
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/index.js